import ReactDOM from 'react-dom/client';
import {
  HashRouter,
  Route,
  Routes,
} from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';

import TagManager from 'react-gtm-module';
import { UtmService } from './services/UtmService';
import { VisualViewport } from './components/visual-viewport';
import Celular from './pages/cadastro-celular';
import Cpf from './pages/cadastro-cpf';
import Email from './pages/cadastro-email';
import Endereco from './pages/cadastro-endereco';
import FinalizadoAindaNao from './pages/cadastro-finalizado-ainda-nao';
import Finalizado from './pages/cadastro-finalizado-botoes';
import Genero from './pages/cadastro-genero';
import Intro from './pages/cadastro-intro';
import Login from './pages/cadastro-login';
import Nascimento from './pages/cadastro-nascimento';
import Nome from './pages/cadastro-nome';
import Senha from './pages/cadastro-senha';
import Termos from './pages/cadastro-termos';
import CartaApresentacao from './pages/carta-apresentacao';
import Cidade from './pages/cidade';
import CidadePesquisa from './pages/cidade-pesquisa';
import Cursos from './pages/cursos';
import CursosAindaEstuda from './pages/cursos-ainda-estuda';
import CursosCurso from './pages/cursos-curso';
import CursosFim from './pages/cursos-fim';
import CursosFimMes from './pages/cursos-fim-mes';
import CursosInicioAno from './pages/cursos-inicio';
import CursosInstituicao from './pages/cursos-instituicao';
import CursosOutro from './pages/cursos-outro';
import CursosPossuiNao from './pages/cursos-possui-nao';
import CursosTipo from './pages/cursos-tipo';
import DadosProfissionais from './pages/dados-profissionais';
import Deficiencia from './pages/cv-deficiencia';
import EstadoCivil from './pages/cv-estado-civil';
import Nacionalidade from './pages/cv-nacionalidade';
import Escolaridade from './pages/escolaridade';
import EscolaridadeAindaEstuda from './pages/escolaridade-ainda-estuda';
import EscolaridadeCurso from './pages/escolaridade-curso';
import EscolaridadeFim from './pages/escolaridade-fim';
import EscolaridadeInicio from './pages/escolaridade-inicio';
import EscolaridadeInstituicao from './pages/escolaridade-instituicao';
import ExperienciaAdicionarOutra from './pages/experiencia-adicionar-outra';
import ExperienciaAindaTrabalha from './pages/experiencia-ainda-trabalha';
import ExperienciaAtividades from './pages/experiencia-atividades';
import ExperienciaCargo from './pages/experiencia-cargo';
import ExperienciaEmpresa from './pages/experiencia-empresa';
import ExperienciaEntrada from './pages/experiencia-entrada';
import ExperienciaPossuiNao from './pages/experiencia-possui-nao';
import ExperienciaSaida from './pages/experiencia-saida';
import ExperienciasProfissionais from './pages/experiencias-profissionais';
import IdiomasAdicionarOutro from './pages/idiomas-adicionar-outro';
import IdiomasApenasPortugues from './pages/idiomas-apenas-portugues';
import IdiomasInicio from './pages/idiomas-inicio';
import IdiomasNivel from './pages/idiomas-nivel';
import IdiomasOutro from './pages/idiomas-outro';
import MeuCurriculo from './pages/meu-curriculo';
import ObjetivosProfissionaisPesquisa from './pages/objetivos-profissionais-pesquisa';
import PerguntasFim from './pages/perguntas-fim';
import PerguntasInicio from './pages/perguntas-inicio';
import PretensaoSalarial from './pages/pretensao-salarial';


const tagManagerArgs = {
  gtmId: 'GTM-NJCFN8F'
}
TagManager.initialize(tagManagerArgs);

// Antes de renderizar: o fluxo tem ~15 telas e o SignupModelHelper.reset() da
// intro limpa o modelo, entao a origem mora numa chave propria do localStorage.
UtmService.capturarDaUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <VisualViewport>
    <HashRouter>
      <Routes>
        <Route path="/" element={ <Intro /> }></Route>
        <Route path="/login" element={ <Login /> }></Route>
        <Route path="/nome" element={ <Nome /> }></Route>
        <Route path="/genero" element={ <Genero /> }></Route>
        <Route path="/nascimento" element={ <Nascimento /> }></Route>
        <Route path="/celular" element={ <Celular /> }></Route>
        <Route path="/email" element={ <Email /> }></Route>
        <Route path="/senha" element={ <Senha /> }></Route>
        <Route path="/cpf" element={ <Cpf /> }></Route>
        <Route path="/endereco" element={ <Endereco /> }></Route>
        <Route path="/cidade" element={ <Cidade /> }></Route>
        <Route path="/cidade-pesquisa" element={ <CidadePesquisa /> }></Route>
        <Route path="/termos" element={ <Termos /> }></Route>
        <Route path="/deficiencia" element={ <Deficiencia /> }></Route>
        <Route path="/estado-civil" element={ <EstadoCivil /> }></Route>
        <Route path="/nacionalidade" element={ <Nacionalidade /> }></Route>
        <Route path="/pretensao-salarial" element={ <PretensaoSalarial /> }></Route>
        <Route path="/objetivos-profissionais" element={ <ObjetivosProfissionaisPesquisa /> }></Route>
        <Route path="/objetivos-profissionais-pesquisa" element={ <ObjetivosProfissionaisPesquisa /> }></Route>
        <Route path="/dados-profissionais" element={ <DadosProfissionais /> }></Route>
        <Route path="/finalizado" element={ <Finalizado /> }></Route>
        <Route path="/finalizado-ainda-nao" element={ <FinalizadoAindaNao /> }></Route>
        <Route path="/experiencias-profissionais" element={ <ExperienciasProfissionais /> }></Route>
        <Route path="/experiencia-possui-nao" element={ <ExperienciaPossuiNao /> }></Route>
        <Route path="/experiencia-cargo" element={ <ExperienciaCargo /> }></Route>
        <Route path="/experiencia-empresa" element={ <ExperienciaEmpresa /> }></Route>
        <Route path="/experiencia-atividades" element={ <ExperienciaAtividades /> }></Route>
        <Route path="/experiencia-ainda-trabalha" element={ <ExperienciaAindaTrabalha /> }></Route>
        <Route path="/experiencia-entrada" element={ <ExperienciaEntrada /> }></Route>
        <Route path="/experiencia-saida" element={ <ExperienciaSaida /> }></Route>
        <Route path="/experiencia-adicionar-outra" element={ <ExperienciaAdicionarOutra /> }></Route>
        <Route path="/escolaridade" element={ <Escolaridade /> }></Route>
        <Route path="/escolaridade-curso" element={ <EscolaridadeCurso /> }></Route>
        <Route path="/escolaridade-instituicao" element={ <EscolaridadeInstituicao /> }></Route>
        <Route path="/escolaridade-ainda-estuda" element={ <EscolaridadeAindaEstuda /> }></Route>
        <Route path="/escolaridade-inicio" element={ <EscolaridadeInicio /> }></Route>
        <Route path="/escolaridade-fim" element={ <EscolaridadeFim /> }></Route>
        <Route path="/cursos" element={ <Cursos /> }></Route>
        <Route path="/cursos-possui-nao" element={ <CursosPossuiNao /> }></Route>
        <Route path="/cursos-tipo" element={ <CursosTipo /> }></Route>
        <Route path="/cursos-outro" element={ <CursosOutro /> }></Route>
        <Route path="/cursos-instituicao" element={ <CursosInstituicao /> }></Route>
        <Route path="/cursos-curso" element={ <CursosCurso /> }></Route>
        <Route path="/cursos-ainda-estuda" element={ <CursosAindaEstuda /> }></Route>
        <Route path="/cursos-inicio" element={ <CursosInicioAno /> }></Route>
        <Route path="/cursos-fim" element={ <CursosFim /> }></Route>
        <Route path="/cursos-fim-mes" element={ <CursosFimMes /> }></Route>
        <Route path="/idiomas-inicio" element={ <IdiomasInicio /> }></Route>
        <Route path="/idiomas-apenas-portugues" element={ <IdiomasApenasPortugues /> }></Route>
        <Route path="/idiomas-outro" element={ <IdiomasOutro /> }></Route>
        <Route path="/idiomas-nivel" element={ <IdiomasNivel /> }></Route>
        <Route path="/idiomas-adicionar-outro" element={ <IdiomasAdicionarOutro /> }></Route>
        <Route path="/carta-apresentacao" element={ <CartaApresentacao /> }></Route>
        <Route path="/perguntas/:profissaoId" element={ <PerguntasInicio /> }></Route>
        <Route path="/perguntas/sucesso" element={ <PerguntasFim /> }></Route>
        <Route path="/meu-curriculo" element={ <MeuCurriculo /> }></Route>
      </Routes>
    </HashRouter>
  </VisualViewport>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
